import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "../_helpers";
import { getStoredValue } from "../_helpers/storagehelper";

const name = "archived";
const initialState = createInitialState();
// const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  // reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const archivedActions = { ...slice.actions, ...extraActions };
export const archivedReducer = slice.reducer;

// implementation
function createInitialState() {
  return {
    error: null,
    PublicInboxArchiveMessageSearch:[],
    PULoginUnreadNotificationCount:[],
    
    user: getStoredValue("user"),
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/Inbox`;
// const MessageBaseUrl = `${process.env.REACT_APP_API_URL}/Kiosk/MyMessage`;
const MessageBaseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/MyAccount`;
  
  return {
    PublicInboxArchiveMessageSearch: PublicInboxArchiveMessageSearch(),
    PULoginUnreadNotificationCount: PULoginUnreadNotificationCount(),
  };
  function PublicInboxArchiveMessageSearch() {
    return createAsyncThunk(
      `${name}/PublicInboxArchiveMessageSearchWeb`,
      async ( data ) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicInboxArchiveMessageSearchWeb?`,
          data
        )
    );
  }
   function PULoginUnreadNotificationCount() {
     return createAsyncThunk(
       `${name}/PublicUserLoginUnreadNotificationCount`,
       async ({ publicUserId }) =>
         await fetchWrapper.get(
           `${MessageBaseUrl}/PublicUserLoginUnreadNotificationCount?publicUserId=${publicUserId}`
         )
     );
   }
}

function createExtraReducers(builder) {
  builder
    // Handle PublicInboxArchiveMessageSearch actions
    .addCase(extraActions.PublicInboxArchiveMessageSearch.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.PublicInboxArchiveMessageSearch.fulfilled,
      (state, action) => {
       // state.PublicInboxArchiveMessageSearchResponse = [];
        state.PublicInboxArchiveMessageSearch = action.payload;
      }
    )
    .addCase(
      extraActions.PublicInboxArchiveMessageSearch.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )
    // Handle  PULoginUnreadNotificationCount
    .addCase(extraActions.PULoginUnreadNotificationCount.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.PULoginUnreadNotificationCount.fulfilled,
      (state, action) => {
        state.PULoginUnreadNotificationCountResponse = [];
        state.PULoginUnreadNotificationCount = action.payload;
      }
    )
    .addCase(
      extraActions.PULoginUnreadNotificationCount.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    );
}

